/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import imgix from 'js/lib/imgix';

import { Typography2 } from '@coursera/cds-core';

import type { SocialProofStatisticType } from 'bundles/career-plans/components/data/types/career-plans';
import CareerPlansSocialProof from 'bundles/career-plans/components/header/CareerPlansSocialProof';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/CareerPlansHeader';

const styles = {
  pageDescription: css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

type Props = {
  backgroundImageUrl?: string;
  pageName: string;
  pageDescription: string;
  socialProofStatistics: Array<SocialProofStatisticType>;
  socialProofStatisticsSource?: string;
  socialProofStatisticsSourceDescription?: string;
};

const CareerPlansHeader = ({
  backgroundImageUrl,
  pageName,
  pageDescription,
  socialProofStatistics,
  socialProofStatisticsSource,
  socialProofStatisticsSourceDescription,
}: Props) => {
  const IMGIX_PARAMS = {
    width: 2280,
    auto: 'format,compress',
  };
  const headerStyle = {
    backgroundImage: backgroundImageUrl ? `url(${imgix.processImage(backgroundImageUrl, IMGIX_PARAMS)})` : undefined,
  };

  return (
    <div className="rc-CareerPlansHeader careerPlans-purple-bg" style={headerStyle} data-e2e="CareerPlansHeader">
      <section className="careerPlans-container">
        <div className="careerPlans-container--main">
          <h2 className="careerPlansHeader-subHeader careerPlans-sectionHeader">{_t('Career Learning Paths')}</h2>
          <h1 className="careerPlansHeader-header careerPlans-header" data-e2e="CareerPlansHeader-name">
            {pageName}
          </h1>
          <Typography2
            css={styles.pageDescription}
            component="p"
            color="invertBody"
            data-e2e="CareerPlansHeader-description"
          >
            {pageDescription}
          </Typography2>
        </div>
        <CareerPlansSocialProof
          socialProofStatistics={socialProofStatistics}
          socialProofStatisticsSource={socialProofStatisticsSource}
          socialProofStatisticsSourceDescription={socialProofStatisticsSourceDescription}
        />
      </section>
    </div>
  );
};

export default CareerPlansHeader;
